import React, { useState } from 'react';
import { Menu, ShoppingCart, Package } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import logoImage from './images/logowide.png';
import Logo from './images/logo.png';
import Sidebar from './Sidebar';
import Login from './Login';

const Header = ({ cart, orders, setScreen, calculateTotal }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {/* Header */}
      <header className="z-40 bg-primary dark:bg-primary-dark text-primary-text dark:text-primary-text-dark shadow-md p-3 flex justify-between items-center fixed w-full top-0 z-20 border-b border-secondary">
        {/* Left: Menu and Logo */}
        <div className="flex items-center justify-center w-full">
          <Menu
            size={30}
            className="cursor-pointer text-secondary hover:text-primary-text-dark dark:hover:text-primary-text transition-colors absolute left-4"
            onClick={() => setSidebarOpen(true)}
          />
          <div className="flex items-center cursor-pointer" onClick={() => setScreen('/')}>
            <img
              src={Logo}
              alt="Logo"
              className="h-10 w-auto max-w-[50px] object-contain"
            />
            <img
              src={logoImage}
              alt="Logo Text"
              className="h-10 w-auto max-w-[150px] object-contain"
            />
          </div>
        </div>

        {/* Right-aligned icons */}
        <div className="flex items-center space-x-4">
          {!isAdminRoute && (
            <>
              <div className="relative cursor-pointer" onClick={() => setScreen('/orders')}>
                <Package
                  size={24}
                  className="text-secondary hover:text-primary-text-dark dark:hover:text-primary-text transition-colors"
                />
                <p className="text-xs text-secondary">Order</p>
              </div>

              <div className="relative cursor-pointer" onClick={() => setScreen('/cart')}>
                <ShoppingCart
                  size={24}
                  className="text-secondary hover:text-primary-text-dark dark:hover:text-primary-text transition-colors"
                />
                <p className="text-xs text-secondary">Cart</p>
                {cart.length > 0 && (
                  <span
                    className="absolute -top-1 -right-1 bg-secondary text-primary-text dark:text-primary-text-dark rounded-full w-4 h-4 flex items-center justify-center text-[10px] font-semibold"
                  >
                    {cart.length}
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </header>

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        setLoginOpen={setLoginOpen}
        setScreen={setScreen}
        isAdminRoute={isAdminRoute}
      />

      {/* Login Full-Screen Component */}
      <Login isOpen={loginOpen} setIsOpen={setLoginOpen} />
    </>
  );
};

export default Header;